var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconMedical48Filled = function SvgIconMedical48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.4 15.3h-3.2v-3.1c0-1.6-1.3-2.9-2.9-2.9h-6.6c-1.6 0-2.9 1.3-2.9 2.9v3.1h-3.2a5.31 5.31 0 0 0-5.3 5.3v12.8c0 2.92 2.38 5.3 5.3 5.3h18.8c2.92 0 5.3-2.38 5.3-5.3V20.6c0-2.92-2.38-5.3-5.3-5.3Zm-11.2 6.2h3.6v3.7h3.7v3.6h-3.7v3.7h-3.6v-3.7h-3.7v-3.6h3.7v-3.7Zm-1-8.8h5.6v2.6h-5.6v-2.6Z",
    fill: "current"
  })));
};
export default SvgIconMedical48Filled;